module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Doppio_Senso-BN.3870ca1b.svg";